export default "__VITE_ASSET__DkWvGLuL__"